import React from 'react';
import MenuItem from './MenuItem';
import Slider from './Icons/profile';
import { useTheme } from '@mui/material/styles';
import { Chart1, ChartCircle, Task } from 'iconsax-react';

export default function BottomNavigation(props) {
  const { active, setActive } = props;
  const theme = useTheme();
  
  const inactiveColor = theme.palette.text.secondary;
  const activeIconColor = theme.palette.primary.contrastText;

  return (
    <div
      className={'menu-bar-horizontal'}
      id={'menu-bar-horizontal'}
      style={{
        padding: '10px 10px calc(10px + env(safe-area-inset-bottom, 0px))',
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        flexWrap: 'nowrap',
        gap: 4,
      }}
    >
      <MenuItem
        value={'missions'}
        logo={
          <ChartCircle
            size="24"
            color={active === 'missions' ? activeIconColor : inactiveColor}
          />
        }
        text={'ماموریت‌ها'}
        isActive={active === 'missions'}
        setActive={setActive}
        color={activeIconColor}
        backgroundColor={theme.palette.primary.main}
        width={56}
      />
      {/* <MenuItem
        value={'warehouse'}
        logo={
          <Task size="24" color={active === 'warehouse' ? activeIconColor : inactiveColor} />
        }
        text={'تحویل به انبار'}
        isActive={active === 'warehouse'}
        setActive={setActive}
        color={activeIconColor}
        backgroundColor={theme.palette.primary.main}
        width={56}
      /> */}
      <MenuItem
        value={'reports'}
        logo={
          <Chart1
            size="24"
            color={active === 'reports' ? activeIconColor : inactiveColor}
          />
        }
        text={'گزارشات'}
        isActive={active === 'reports'}
        setActive={setActive}
        color={activeIconColor}
        backgroundColor={theme.palette.primary.main}
        width={56}
      />

      <MenuItem
        value={'profile'}
        logo={
          <Slider
            width={24}
            height={24}
            fill={active === 'profile' ? activeIconColor : inactiveColor}
            stroke={active === 'profile' ? activeIconColor : inactiveColor}
          />
        }
        text={'پروفایل'}
        isActive={active === 'profile'}
        setActive={setActive}
        color={activeIconColor}
        backgroundColor={theme.palette.primary.main}
        width={56}
      />
    </div>
  );
}
